import styled from 'styled-components';

const TextAreaComponent = styled.textarea`
  ${({ theme, touched, invalid }) =>
    touched &&
    invalid &&
    `
      border-color: ${theme.colors.negative};

      &:hover {
        border-color: ${theme.colors.negative_bg};
      }

      &:focus {
        border-color: ${theme.colors.negative_bg};
        box-shadow: 0 0 0 0.2em rgb(207 20 43 / 25%);
      }
  `}
`;

function TextArea ({...props}) {
  return (
    <div className="se-textarea-container">
      <TextAreaComponent className="se-textarea se-textarea--md" {...props} />
    </div>
  );
}

export default TextArea;